import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetCategoriesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CategoryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.CategoryDocumentSortInput> | Types.CategoryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', categories?: { __typename?: 'CategoriesConnection', totalCount: number, nodes?: Array<{ __typename?: 'CategoryDocument', id: string, tenantId: string, status: Types.CategoryStatus, usageCount?: number | null, incomeGlAccountId?: string | null, category: { __typename?: 'CategoryData', code: string }, incomeGlAccount?: { __typename?: 'MergeDevAccountDocument', name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type CategoryDataFragment = { __typename?: 'CategoryData', code: string };

export type CategoryShippingUomDataFragment = { __typename?: 'CategoryData', code: string, shippingUomId?: string | null };

export type CategoryShippingUomNodeFragment = { __typename?: 'CategoryDocument', id: string, tenantId: string, status: Types.CategoryStatus, usageCount?: number | null, incomeGlAccountId?: string | null, category: { __typename?: 'CategoryData', code: string, shippingUomId?: string | null } };

export type GetCategoriesWithShippingUomQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CategoryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.CategoryDocumentSortInput> | Types.CategoryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCategoriesWithShippingUomQuery = { __typename?: 'Query', categories?: { __typename?: 'CategoriesConnection', totalCount: number, nodes?: Array<{ __typename?: 'CategoryDocument', id: string, tenantId: string, status: Types.CategoryStatus, usageCount?: number | null, incomeGlAccountId?: string | null, category: { __typename?: 'CategoryData', code: string, shippingUomId?: string | null } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type CategoryFragment = { __typename?: 'CategoryPayloadData', id: string, tenantId: string, category: { __typename?: 'CategoryData', code: string } };

export type CategoryNodeFragment = { __typename?: 'CategoryDocument', id: string, tenantId: string, status: Types.CategoryStatus, usageCount?: number | null, incomeGlAccountId?: string | null, category: { __typename?: 'CategoryData', code: string }, incomeGlAccount?: { __typename?: 'MergeDevAccountDocument', name: string, accountNumber: string, status: Types.MergeDevAccountStatus } | null };

export const CategoryShippingUomDataFragmentDoc = new TypedDocumentString(`
    fragment CategoryShippingUomData on CategoryData {
  code
  shippingUomId
}
    `, {"fragmentName":"CategoryShippingUomData"});
export const CategoryShippingUomNodeFragmentDoc = new TypedDocumentString(`
    fragment CategoryShippingUomNode on CategoryDocument {
  id
  tenantId
  category {
    ...CategoryShippingUomData
  }
  status
  usageCount
  incomeGlAccountId
}
    fragment CategoryShippingUomData on CategoryData {
  code
  shippingUomId
}`, {"fragmentName":"CategoryShippingUomNode"});
export const CategoryDataFragmentDoc = new TypedDocumentString(`
    fragment CategoryData on CategoryData {
  code
}
    `, {"fragmentName":"CategoryData"});
export const CategoryFragmentDoc = new TypedDocumentString(`
    fragment Category on CategoryPayloadData {
  id
  tenantId
  category {
    ...CategoryData
  }
}
    fragment CategoryData on CategoryData {
  code
}`, {"fragmentName":"Category"});
export const CategoryNodeFragmentDoc = new TypedDocumentString(`
    fragment CategoryNode on CategoryDocument {
  id
  tenantId
  category {
    ...CategoryData
  }
  status
  usageCount
  incomeGlAccountId
  incomeGlAccount {
    name
    accountNumber
    status
  }
}
    fragment CategoryData on CategoryData {
  code
}`, {"fragmentName":"CategoryNode"});
export const GetCategoriesDocument = new TypedDocumentString(`
    query GetCategories($where: CategoryDocumentFilterInput, $order: [CategoryDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  categories(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...CategoryNode
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment CategoryData on CategoryData {
  code
}
fragment CategoryNode on CategoryDocument {
  id
  tenantId
  category {
    ...CategoryData
  }
  status
  usageCount
  incomeGlAccountId
  incomeGlAccount {
    name
    accountNumber
    status
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetCategoriesWithShippingUomDocument = new TypedDocumentString(`
    query GetCategoriesWithShippingUom($where: CategoryDocumentFilterInput, $order: [CategoryDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  categories(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...CategoryShippingUomNode
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment CategoryShippingUomData on CategoryData {
  code
  shippingUomId
}
fragment CategoryShippingUomNode on CategoryDocument {
  id
  tenantId
  category {
    ...CategoryShippingUomData
  }
  status
  usageCount
  incomeGlAccountId
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCategories: build.query<GetCategoriesQuery, GetCategoriesQueryVariables | void>({
      query: (variables) => ({ document: GetCategoriesDocument, variables })
    }),
    GetCategoriesWithShippingUom: build.query<GetCategoriesWithShippingUomQuery, GetCategoriesWithShippingUomQueryVariables | void>({
      query: (variables) => ({ document: GetCategoriesWithShippingUomDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCategoriesQuery, useLazyGetCategoriesQuery, useGetCategoriesWithShippingUomQuery, useLazyGetCategoriesWithShippingUomQuery } = injectedRtkApi;
